import React from "react";
import { useDropzone } from "react-dropzone";
import { Box, Typography, Grid, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Image } from "antd";
import DescriptionIcon from "@mui/icons-material/Description";

export default function UploadFilesComponent({
  files,
  setFiles,
  multiple = true,
  accept = "image/*,application/pdf",
  maxFiles = 5,
  text,
}) {
  const displayText =
    text ||
    "Arrastra y suelta archivos aquí, o haz clic para seleccionar archivos";
  const { getRootProps, getInputProps } = useDropzone({
    accept,
    multiple,
    maxFiles,
    onDrop: (acceptedFiles) => {
      const newFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: file.type.startsWith("image/")
            ? URL.createObjectURL(file)
            : null,
        })
      );
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    },
  });

  const removeFile = (fileName, event) => {
    event.stopPropagation();
    setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  const preventClickPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: "2px dashed #aaa",
        padding: "10px",
        borderRadius: "10px",
        textAlign: "center",
        cursor: "pointer",
        width: "100%", // Ensure the container takes full width
        boxSizing: "border-box",
        minHeight: "90px",
      }}
    >
      <input {...getInputProps()} />
      <Typography variant="body1" color="textSecondary" gutterBottom>
        {displayText}
      </Typography>
      <Grid
        container
        spacing={2}
        justifyContent={multiple ? "flex-start" : "center"}
      >
        {files.map((file, index) => (
          <Grid item xs={4} sm={3} md={2} key={index}>
            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: "5px",
                overflow: "hidden",
                position: "relative",
                padding: "4px",
                height: "60px",
                width: "55px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f9f9f9",
              }}
              onClick={preventClickPropagation}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  marginBottom: "4px",
                }}
              >
                <Tooltip title={file.name}>
                  <Typography
                    variant="caption"
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "50px", // Adjusted max width for title
                      fontSize: "0.7rem",
                    }}
                  >
                    {file.name}
                  </Typography>
                </Tooltip>
                <IconButton
                  aria-label="delete"
                  size="small"
                  onClick={(event) => removeFile(file.name, event)}
                  sx={{ padding: "2px" }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
              {file.preview ? (
                <Image
                  src={file.preview}
                  alt={file.name}
                  preview={true}
                  style={{
                    width: "100%",
                    height: "40px",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />
              ) : (
                <DescriptionIcon
                  sx={{
                    fontSize: 30, // Reduced icon size
                    color: "#aaa",
                  }}
                />
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
